import React, { Component } from 'react';
import { Platform } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  has as _has,
  isFunction as _isFunction,
  cloneDeep as _cloneDeep,
  isNil as _isNil,
  filter as _filter,
  map as _map,
  find as _find,
  get as _get,
  includes as _includes,
  isEmpty as _isEmpty,
} from 'lodash';
import PropTypes from 'prop-types';

import { VFScreen, HeaderTabs, TabView } from '@vfgroup-oneplatform/foundation/Components';
import ManualRefresh from '@vfgroup-oneplatform/foundation/Components/ManualRefresh';
import { Images, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import AddOns from '../../../BusinessOverview/AddOns';
import Budget from '../../../BusinessOverview/Budget';
import Devices from '../../../BusinessOverview/Devices';
import Licences from '../../../BusinessOverview/Licences';
import Plans from '../../../BusinessOverview/Plans/Plans';
import Settings from '../../../BusinessOverview/Settings';
import Usage, { getLabelBasedOnTabId } from '../../../BusinessOverview/Usage/Usage';
import {
  TABS,
  TABS_LABELS,
  USAGE_CATEGORIES_IS_LOADING,
} from '../../../BusinessOverview/Utils/Enums';
import BusinessOverviewTab from '../BusinessOverviewTab';

import styles from './BusinessOverviewTabbedView.Styles';

class BusinessOverviewTabbedView extends Component {
  constructor(props) {
    super(props);
    this.HeaderTabsProps = this.getHeaderTabsProps();

    this.state = {
      activeTab: 0,
      activeSubTabUsage: null,
      lastUpdateTime: new Date(),
    };
  }

  componentDidMount() {
    const { activeTab } = this.state;

    this.onActiveTabChange(activeTab);
  }

  componentDidUpdate(prevProps, prevState) {
    const wasAnyTabLoading = this.getIsAnyTabLoading(prevProps);
    const isAnyTabLoading = this.getIsAnyTabLoading(this.props);

    const wasActiveTabInErrorState = this.getIsActiveTabInErrorState(prevProps);
    const isActiveTabInErrorState = this.getIsActiveTabInErrorState(this.props);

    if (
      (wasAnyTabLoading !== isAnyTabLoading && isAnyTabLoading) ||
      (prevState.activeTab === this.state.activeTab &&
        !wasActiveTabInErrorState &&
        isActiveTabInErrorState)
    ) {
      this.scrollToOffset(0, false);
    }
  }

  onActiveTabChange = activeTab => {
    if (this.state.activeTab === activeTab) {
      return;
    }
    const { onActiveTabChange } = this.props;

    this.setState({ activeTab });

    this.scrollToOffset(0, false);

    if (_isFunction(onActiveTabChange)) {
      onActiveTabChange(activeTab, this.HeaderTabsProps[activeTab]);
    }
  };

  onSecondaryButtonPress = hideBanner => {
    hideBanner();
  };

  getHeaderTabsProps = () => {
    const { customTabs, tabsToExclude } = this.props;

    const _customTabs = this.filterTabsPerPlatform(customTabs);

    const _tabs = this.filterTabsBasedOnExcluded(TABS, tabsToExclude);

    const allTabs = this.mergeCustomTabsWithOriginal(_tabs, _customTabs);

    const overrideTabs = this.overrideTabs(allTabs);

    return _map(overrideTabs, ({ key, tab_key }, index) => ({ key, tab_key, index }));
  };

  getIsAnyTabLoading = props => {
    const {
      plansProps,
      usageProps,
      licencesProps,
      addOnsProps,
      devicesProps,
      budgetProps,
      settingsProps,
    } = props;

    const tab = this.HeaderTabsProps[this.state.activeTab];

    switch (tab.key) {
      case TABS_LABELS.PLANS:
        return plansProps?.isLoading;

      case TABS_LABELS.LICENCES:
        return licencesProps?.isLoading;

      case TABS_LABELS.ADDONS:
        return addOnsProps?.isLoading || addOnsProps?.isRequestedAddOnsLoading;

      case TABS_LABELS.DEVICES:
        return devicesProps?.isLoading;

      case TABS_LABELS.USAGE:
        const isSubCategoryLoading = getLabelBasedOnTabId(this.state.activeSubTabUsage);
        return (
          usageProps?.isLoading ||
          usageProps?.isUsageUsersLoading ||
          usageProps?.isUsageCategoriesLoading?.[USAGE_CATEGORIES_IS_LOADING[isSubCategoryLoading]]
        );
      case TABS_LABELS.SETTINGS:
        return settingsProps?.isLoading;

      case TABS_LABELS.BUDGET:
        return budgetProps?.isLoading;

      default:
        return false;
    }
  };

  getIsActiveTabInErrorState = props => {
    const { plansProps, licencesProps, devicesProps, addOnsProps, budgetProps, settingsProps } =
      props;
    const { activeTab } = this.state;

    const tab = this.HeaderTabsProps[activeTab];

    switch (tab.key) {
      case TABS_LABELS.PLANS:
        return !_isEmpty(plansProps?.error);

      case TABS_LABELS.LICENCES:
        return !_isEmpty(licencesProps?.error);

      case TABS_LABELS.DEVICES:
        return !_isEmpty(devicesProps?.error);

      case TABS_LABELS.ADDONS:
        return !_isEmpty(addOnsProps?.error);

      case TABS_LABELS.BUDGET:
        return !_isEmpty(budgetProps?.error);

      case TABS_LABELS.SETTINGS:
        return !_isEmpty(settingsProps?.error);
      case TABS_LABELS.USAGE:
      default:
        return false;
    }
  };

  getScrollViewRef = ref => {
    this.scrollViewRef = ref;

    if (_isFunction(_get(this.props, 'vfScreenProps.getScrollViewRef'))) {
      this.props.vfScreenProps.getScrollViewRef(ref);
    }
  };

  overrideTabs = tabs => {
    const finalTabs = _cloneDeep(tabs);
    const {
      plansProps,
      addOnsProps,
      usageProps,
      licencesProps,
      devicesProps,
      budgetProps,
      settingsProps,
    } = this.props;

    const tabsPropsArray = [
      plansProps?.tabLabelProps,
      addOnsProps?.tabLabelProps,
      usageProps?.tabLabelProps,
      licencesProps?.tabLabelProps,
      devicesProps?.tabLabelProps,
      budgetProps?.tabLabelProps,
      settingsProps?.tabLabelProps,
    ];

    const customTabs = tabsPropsArray.filter(tab => !!tab && tab);
    const customTabsKeys = customTabs.map(tab => tab.key);

    finalTabs.forEach(tab => {
      if (customTabsKeys.includes(tab.key)) {
        const indexOfCustom = customTabs.findIndex(c => c.key === tab.key);
        tab.tab_key = customTabs[indexOfCustom].tab_key;
      }
    });

    return finalTabs;
  };

  filterTabsPerPlatform = tabs => {
    return _filter(tabs, tab => {
      return _isNil(tab.platform) || tab.platform === Platform.OS;
    });
  };

  filterTabsBasedOnExcluded = (tabs, tabsToExclude) => {
    return _filter(tabs, tab => !_includes(tabsToExclude, tab?.key));
  };

  mergeCustomTabsWithOriginal = (tabs, cutomTabs) => {
    const mergedTabs = _cloneDeep(tabs);

    for (let i = 0; i < cutomTabs.length; i++) {
      if (_has(cutomTabs[i], 'index')) {
        mergedTabs.splice(cutomTabs[i].index, 0, cutomTabs[i]);
      } else {
        mergedTabs.push(cutomTabs[i]);
      }
    }

    return mergedTabs;
  };

  scrollToOffset = (offset, isAnimated) => {
    if (_isFunction(_get(this.scrollViewRef, 'scrollToOffset'))) {
      this.scrollViewRef.scrollToOffset({
        offset: offset,
        animated: isAnimated,
      });
    }
  };

  renderManualRefresh = () => {
    return (
      <ManualRefresh
        onRefresh={this.props.onRefresh}
        images={Images}
        lastUpdateTime={this.state.lastUpdateTime}
        containerStyle={styles.manualRefreshContainerStyle}
        refreshViewStyle={styles.refreshViewStyle}
        setLastUpdateTime={() => this.setState({ lastUpdateTime: new Date() })}
        refreshTitleStatusKeys={{
          updating: 'soho_requests_refresh_title_updating',
          updatedNow: 'soho_requests_refresh_title_updated_just_now',
          sinceLastUpdate: 'soho_requests_refresh_title_updated_min_ago',
        }}
      />
    );
  };

  renderTabs = tabs => {
    const {
      plansProps,
      usageProps,
      licencesProps,
      devicesProps,
      addOnsProps,
      budgetProps,
      settingsProps,
      withTray,
      images,
      customTabs,
      theme,
      isCurrencyFirst,
    } = this.props;

    return _map(tabs, ({ key }, index) => (
      <TabView index={index}>
        {this.renderTab({
          key,
          plansProps,
          usageProps,
          licencesProps,
          devicesProps,
          addOnsProps,
          budgetProps,
          settingsProps,
          withTray,
          images,
          theme,
          customTabs,
          isCurrencyFirst,
        })}
      </TabView>
    ));
  };

  renderTab = ({
    key,
    plansProps,
    usageProps,
    licencesProps,
    devicesProps,
    addOnsProps,
    budgetProps,
    settingsProps,
    withTray,
    images,
    theme,
    customTabs,
    isCurrencyFirst,
  }) => {
    switch (key) {
      case TABS_LABELS.PLANS:
        return this.renderTabContent(
          Plans,
          {
            images,
            withTray,
            isCurrencyFirst,
            ...plansProps,
          },
          key,
        );

      case TABS_LABELS.USAGE:
        return this.renderTabContent(
          Usage,
          {
            images,
            withTray,
            setActiveSubTabUsageState: activeSubTabUsage => this.setState({ activeSubTabUsage }),
            ...usageProps,
          },
          key,
        );

      case TABS_LABELS.LICENCES:
        return this.renderTabContent(
          Licences,
          {
            images,
            withTray,
            theme,
            isCurrencyFirst,
            ...licencesProps,
          },
          key,
        );

      case TABS_LABELS.DEVICES:
        return this.renderTabContent(
          Devices,
          {
            images,
            withTray,
            isCurrencyFirst,
            ...devicesProps,
          },
          key,
        );
      case TABS_LABELS.SETTINGS:
        return this.renderTabContent(
          Settings,
          {
            images,
            withTray,
            ...settingsProps,
          },
          key,
        );
      case TABS_LABELS.ADDONS:
        return this.renderTabContent(
          AddOns,
          {
            images,
            withTray,
            isCurrencyFirst,
            ...addOnsProps,
          },
          key,
        );

      case TABS_LABELS.BUDGET:
        return this.renderTabContent(
          Budget,
          {
            images,
            withTray,
            isCurrencyFirst,
            ...budgetProps,
          },
          key,
        );

      default:
        return _find(customTabs, tab => tab.key === key)?.renderTabContent();
    }
  };

  renderTabContent = (TabComponent, tabProps, key) => {
    const { userName, withPageBanner, pageBannerProps, getTabPageBannerProps } = this.props;

    const { userName: bannerUserName = userName } = pageBannerProps;

    const { numberToReview, withPageBanner: tabWithPageBanner } = tabProps;
    const withPageBannerFlag = withPageBanner || tabWithPageBanner;
    const _pageBannerProps = {
      containerViewStyle: styles.pageBannerContainerStyle,
      description:
        numberToReview === 1
          ? 'soho_business_overview_cvm_page_banner_description_singular'
          : 'soho_business_overview_cvm_page_banner_description_plural',
      withSecondaryButton: true,
      primaryButtonTitle: 'soho_business_overview_cvm_page_banner_primary_button_title',
      secondaryButtonTitle: 'soho_business_overview_cvm_page_banner_secondary_button_title',
      onSecondaryButtonPress: this.onSecondaryButtonPress,
      titleStyle: styles.pageBannerTitleStyle,
      ...(_isFunction(getTabPageBannerProps) && getTabPageBannerProps(key, tabProps)),
      titlePlaceholders: [bannerUserName, numberToReview],
      ...pageBannerProps,
    };

    const _withPageBanner =
      tabProps?.isLoading || !_isNil(tabProps?.error) ? false : withPageBannerFlag;

    return (
      <BusinessOverviewTab
        TabComponent={TabComponent}
        pageBannerProps={_pageBannerProps}
        withPageBanner={_withPageBanner}
        {...tabProps}
      />
    );
  };

  renderDescriptionInfoSection = () => {
    const { onRefresh, renderManualRefreshLoading } = this.props;

    if (_isFunction(onRefresh)) {
      return this.getIsAnyTabLoading(this.props)
        ? renderManualRefreshLoading(styles.updatingContainer)
        : this.renderManualRefresh();
    }
  };

  render() {
    const {
      vfScreenProps,
      onClose,
      title,
      subHeaderTitle,
      subHeaderTitlePlaceholders,
      subHeaderBeforeSubTitle,
      subHeaderMaxHeight,
      subHeaderSubTitle,
      subHeaderSubTitleStyle,
      renderSubHeaderRightComponent,
      subHeaderTitleStyle,
      subHeaderAfterSubTitle,
      subHeaderAfterSubTitleStyle,
      withTabsScroll,
    } = this.props;
    const { activeTab } = this.state;

    const isScrollEnabled =
      !this.getIsAnyTabLoading(this.props) && !this.getIsActiveTabInErrorState(this.props);
    return (
      <VFScreen
        withSubHeader
        onClose={onClose}
        title={title}
        subHeaderTitle={subHeaderTitle}
        subHeaderTitlePlaceholders={subHeaderTitlePlaceholders}
        subHeaderBeforeSubTitle={subHeaderBeforeSubTitle}
        subHeaderSubTitle={subHeaderSubTitle}
        subHeaderSubTitleStyle={subHeaderSubTitleStyle}
        subHeaderTitleStyle={subHeaderTitleStyle}
        subHeaderAfterSubTitle={subHeaderAfterSubTitle}
        subHeaderAfterSubTitleStyle={subHeaderAfterSubTitleStyle}
        renderSubHeaderRightComponent={
          _isFunction(renderSubHeaderRightComponent) ? renderSubHeaderRightComponent : null
        }
        subHeaderDescription={' '}
        renderDescriptionInfo={this.renderDescriptionInfoSection}
        subHeaderMaxHeight={subHeaderMaxHeight}
        configureHeaderTabs={{
          // withTabsScroll: withTabsScroll,
          activeTab,
          setActiveTab: this.onActiveTabChange,
          tabs: this.HeaderTabsProps,
          // scrollEnabled: isScrollEnabled,
          // showsVerticalScrollIndicator: isScrollEnabled,
        }}
        getScrollViewRef={this.getScrollViewRef}
        keyboardShouldPersistTaps="handled"
        {...vfScreenProps}
        {...this.props}
      >
        <HeaderTabs activeTab={activeTab}>{this.renderTabs(this.HeaderTabsProps)}</HeaderTabs>
      </VFScreen>
    );
  }
}

BusinessOverviewTabbedView.defaultProps = {
  images: {},
  withPageBanner: true,
  pageBannerProps: {},
  isCurrencyFirst: false,
  withTabsScroll: false,
};

BusinessOverviewTabbedView.propTypes = {
  customTabs: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      platform: PropTypes.oneOf(['android', 'ios']),
      key: PropTypes.string.isRequired,
      tab_key: PropTypes.string.isRequired,
      renderTabContent: PropTypes.func.isRequired,
    }),
  ),
  tabsToExclude: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
  withPageBanner: PropTypes.bool,
  pageBannerProps: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withTray: PropTypes.bool,
  images: PropTypes.object,
  onActiveTabChange: PropTypes.func,
  vfScreenProps: PropTypes.object,
  plansProps: PropTypes.object,
  usageProps: PropTypes.object,
  budgetProps: PropTypes.object,
  licencesProps: PropTypes.object,
  devicesProps: PropTypes.object,
  settingsProps: PropTypes.object,
  addOnsProps: PropTypes.object,
  userName: PropTypes.string,
  title: PropTypes.string,
  subHeaderTitle: PropTypes.string,
  subHeaderTitlePlaceholders: PropTypes.number,
  subHeaderMaxHeight: PropTypes.number,
  subHeaderAfterSubTitle: PropTypes.string,
  subHeaderTitleStyle: ViewPropTypes.style,
  subHeaderSubTitle: PropTypes.string,
  subHeaderAfterSubTitleStyle: ViewPropTypes.style,
  renderSubHeaderRightComponent: PropTypes.func,
  subHeaderSubTitleStyle: ViewPropTypes.style,
  subHeaderBeforeSubTitle: PropTypes.string,
  getTabPageBannerProps: PropTypes.func,
  isCurrencyFirst: PropTypes.bool,
  withTabsScroll: PropTypes.bool,
  renderManualRefreshLoading: PropTypes.func,
  onRefresh: PropTypes.func,
};

export default withTheme(BusinessOverviewTabbedView);
